var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUnityImg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 273,
    height: 101,
    viewBox: "0 0 273 101",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 272,
    height: 100,
    rx: 4.5,
    fill: "",
    stroke: "#64748b85"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3261_44356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M113.217 63.3321L105.612 50.4032L113.217 37.4744L116.883 50.4032L113.217 63.3321ZM96.2911 62.0704L86.7359 52.4922H101.946L109.551 65.421L96.2911 62.0704ZM96.2911 38.6965L109.512 35.3459L101.907 48.2747H86.6971L96.2911 38.6965ZM115.713 29L98.4359 33.5331L95.8619 37.987L90.6751 37.9474L78 50.4032L90.6751 62.8591L95.8619 62.8195L98.4359 67.2734L115.713 71.8461L120.354 54.8572L117.741 50.4428L120.354 46.028L115.713 29ZM154.947 41.5741C152.646 41.5741 151.086 42.5592 149.916 44.3725H149.838V42.0471H145.782V59.1537H149.916V49.4572C149.916 47.1318 151.359 45.5154 153.348 45.5154C155.22 45.5154 156.624 46.6588 156.624 48.6691V59.1933H160.758V47.9987C160.797 44.2542 158.457 41.5741 154.947 41.5741ZM139.503 51.9405C139.503 54.2268 138.216 55.8032 136.11 55.8032C134.199 55.8032 132.99 54.6998 132.99 52.6896V42.0471H128.856V53.4777C128.856 57.2222 130.962 59.6663 134.745 59.6663C137.124 59.6663 138.45 58.7594 139.581 57.1831H139.698V59.1933H143.676V42.0471H139.542V51.9405H139.503ZM162.981 42.0471H167.115V59.1537H162.981V42.0471ZM162.981 36.7258H167.115V40.1551H162.981V36.7258ZM190.554 42.0471L188.097 49.7724C187.551 51.3492 187.122 53.5173 187.122 53.5173H187.005C187.005 53.5173 186.459 51.3492 185.913 49.7724L183.144 42.0471H178.698L183.261 54.2268C184.236 56.8283 184.548 57.9317 184.548 58.8777C184.548 60.2967 183.807 61.2036 182.052 61.2036H180.453V64.7902H183.105C186.537 64.7902 187.746 63.4107 189.033 59.6267L195 42.0862H190.554V42.0471ZM174.837 54.1477V45.082H177.489V42.0862H174.837V36.7258H170.703V42.0471H168.363V45.0424H170.703V55.0937C170.703 58.326 173.121 59.1933 175.305 59.1933C177.099 59.1933 177.567 59.1142 177.567 59.1142V55.8032H176.514C175.539 55.8427 174.837 55.4093 174.837 54.1477Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3261_44356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 43,
    fill: "white",
    transform: "translate(78 29)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnityImg);
export default __webpack_public_path__ + "static/media/unity-img.2dc227da935a5d78b2cb0850b9c5c78f.svg";
export { ForwardRef as ReactComponent };